import type { StyleSchema } from '@blocknote/core';
import {
  createReactInlineContentSpec,
  type ReactInlineContentImplementation,
} from '@blocknote/react';

export const localToolConfig = {
  type: 'localTool',
  propSchema: {
    toolName: { default: '' },
    argument: { default: '' },
    argumentLabel: { default: '' },
  },
  content: 'none' as const,
};

type LocalToolConfig = typeof localToolConfig;

type LocalToolBadgeRenderProps = Parameters<
  ReactInlineContentImplementation<LocalToolConfig, StyleSchema>['render']
>[0];

/** Format the display text for a local tool badge. */
export const formatLocalToolDisplay = (
  toolName: string,
  argument: string,
  argumentLabel: string
): string => {
  const displayLabel = argumentLabel || argument;

  return displayLabel ? `${toolName}(${displayLabel})` : toolName;
};

export const LocalToolBadgeComponent = ({ inlineContent }: LocalToolBadgeRenderProps) => {
  const { toolName, argument, argumentLabel } = inlineContent.props;
  const displayText = formatLocalToolDisplay(toolName, argument, argumentLabel);

  return (
    <span className="inline-block max-w-full rounded-2xl bg-bg-ai-soft px-1 py-0.5 leading-5 break-all text-ai">
      {displayText}
    </span>
  );
};

export const LocalToolBadge = createReactInlineContentSpec(localToolConfig, {
  render: LocalToolBadgeComponent,
});
